export const Audience = {
  Dashboard: 'dashboard',
  Graph: 'graph',
  Pdf: 'pdf'
}
